import { render, staticRenderFns } from "./SelectPupil.vue?vue&type=template&id=09977c68&scoped=true"
import script from "./SelectPupil.vue?vue&type=script&lang=js"
export * from "./SelectPupil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09977c68",
  null
  
)

export default component.exports